import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import "../styles/formStyles.css";

const hierarchy = [
  "Marketing Director",
  "Deputy Director",
  "Chief General Manager",
  "General Manager",
  "Deputy General Manager",
  "Assisstant General Manager",
  "Marketing Manager",
  "Marketing Executive",
  "Marketing Associate"
];

function Register() {
  const [formData, setFormData] = useState({
    joiningType: "",
    referenceNo: "",
    name: "",
    gender: "",
    dob: "",
    nominee: "",
    relationship: "",
    address: "",
    mobileNo: "",
    panNo: "",
    aadharNo: "",
    cader: "",
    accountNo: "",
    bankName: "",
    branch: "",
    ifscCode: ""
  });

  const [result, setResult] = useState(null);
  const [availableCaders, setAvailableCaders] = useState([]);
  const [user, setUser] = useState(null);
  const [referenceName, setReferenceName] = useState(""); // ✅ New state for reference name
  const [referenceError, setReferenceError] = useState(""); // ✅ For invalid reference

  useEffect(() => {
    const fetchCaders = async () => {
      if (formData.joiningType === "direct") {
        setAvailableCaders(hierarchy);
        setReferenceName("");
        setReferenceError("");
      } else if (formData.joiningType === "reference" && formData.referenceNo) {
        try {
          const res = await axios.get(`https://api.ssvdevelopers.co.in/member/${formData.referenceNo}`);
          const refCader = res.data.cader;
          const refName = res.data.name; // ✅ get the reference name
          setReferenceName(refName || "");
          setReferenceError(""); // ✅ clear previous errors

          const refIndex = hierarchy.indexOf(refCader);
          if (refIndex !== -1) setAvailableCaders(hierarchy.slice(refIndex + 1));
          else setAvailableCaders(hierarchy);
        } catch (err) {
          console.log(err);
          setAvailableCaders(hierarchy);
          setReferenceName("");
          setReferenceError("❌ Invalid Reference ID");
        }
      } else {
        setAvailableCaders([]);
        setReferenceName("");
        setReferenceError("");
      }
    };
    fetchCaders();
  }, [formData.joiningType, formData.referenceNo]);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) setUser(storedUser);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://api.ssvdevelopers.co.in/enroll", formData);
      setResult(res.data);
    } catch (err) {
      setResult({ error: err.response?.data?.error || "Something went wrong" });
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sidebar user={user} setUser={setUser} />

      {/* Main Content */}
      <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
        {!result && (
          <form onSubmit={handleSubmit} style={styles.form}>
            {/* Joining Type */}
            <div style={styles.field}>
              <label style={styles.label}>Joining Type:</label>
              <select
                name="joiningType"
                value={formData.joiningType}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select</option>
                <option value="direct">Direct Joining</option>
                <option value="reference">Through Reference</option>
              </select>
            </div>

            {/* Reference Number */}
            {formData.joiningType === "reference" && (
              <div style={styles.field}>
                <label style={styles.label}>Reference Number:</label>
                <input
                  type="text"
                  name="referenceNo"
                  value={formData.referenceNo}
                  onChange={handleChange}
                  required
                  style={styles.input}
                />
                {referenceName && (
                  <p style={{ color: "green", fontWeight: "bold", marginTop: "5px" }}>
                    Reference Name: {referenceName}
                  </p>
                )}
                {referenceError && (
                  <p style={{ color: "red", fontWeight: "bold", marginTop: "5px" }}>
                    {referenceError}
                  </p>
                )}
              </div>
            )}

            {/* Other Fields */}
            {Object.keys(formData)
              .filter((key) => !["joiningType", "referenceNo"].includes(key))
              .map((key) => (
                <div key={key} style={styles.field}>
                  <label style={styles.label}>{key}:</label>
                  {key === "cader" ? (
                    <select
                      name="cader"
                      value={formData.cader}
                      onChange={handleChange}
                      required
                      style={styles.input}
                    >
                      <option value="">Select Cader</option>
                      {availableCaders.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      name={key}
                      value={formData[key]}
                      onChange={handleChange}
                      required={key === "mobileNo"}
                      style={styles.input}
                    />
                  )}
                </div>
              ))}

            <button type="submit" style={styles.button}>Register</button>
          </form>
        )}

        {/* Success Message */}
        {result && !result.error && (
          <div style={styles.successBox}>
            <h3 style={{ marginBottom: "20px", fontSize: "28px", color: "darkblue" }}>
              Welcome to SSV Developers
            </h3>
            <p style={{ fontSize: "28px", color: "darkgreen" }}>
              🎉 <b>Congratulations Mr/Ms {result.name}</b> 🎉
            </p>
            <p style={{ marginBottom: "20px", fontSize: "24px", color: "red" }}>
              <b>Cader:</b> {result.cader}
            </p>
            <p style={{ marginBottom: "20px", fontSize: "24px", color: "purple" }}>
              <b>ID:</b> {result.Id}
            </p>
            <p style={{ marginBottom: "20px", fontSize: "24px", color: "purple" }}>
              <b>Password:</b> {result.password}
            </p>
          </div>
        )}

        {/* Error Message */}
        {result && result.error && (
          <div style={{ marginTop: "20px", padding: "10px", border: "1px solid red" }}>
            <h3>❌ Registration Failed</h3>
            <p>{result.error}</p>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "30px",
    gap: "15px",
    backgroundColor: "#f0f8ff",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    width: "300px",
  },
  label: {
    marginBottom: "5px",
    fontWeight: "bold",
    fontSize: "16px",
    textAlign: "left",
  },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "16px",
  },
  button: {
    padding: "10px 20px",
    borderRadius: "6px",
    border: "none",
    backgroundColor: "#2c3e50",
    color: "white",
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "10px",
  },
  successBox: {
    marginTop: "50px",
    padding: "40px",
    border: "3px solid green",
    backgroundColor: "lightblue",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    fontWeight: "bold",
    width: "50%",
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: "10px",
  },
};

export default Register;
